// extracted by mini-css-extract-plugin
export default {"App":"footer_App__xl6CI","loadingWrapper":"footer_loadingWrapper__GaSiO","loading":"footer_loading__3U9Ym","content":"footer_content__D-DXA"};